<qw-navbar [username]="username"></qw-navbar>
<div id="content">
    <router-outlet></router-outlet>
</div>
<qw-footer></qw-footer>

<qw-cookie-policy-consent></qw-cookie-policy-consent>